import controller from './date-input-controller';
import template from './date-input.html';

const DateInput = {
    bindings: {
        isDisabled: '<',
        isRequired: '<',
        onDateSelect: '&',
        minDate: '<',
        placeholder: '<',
        selectedDate: '<'
    },
    controller,
    template
};

export default DateInput;



// WEBPACK FOOTER //
// ./app/common/date-input/date-input-component.js